"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OfferHints = void 0;
var _mui = require("@ori-ui/mui");
var _checkoutUi = require("@ori/checkout-ui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../contexts");
var _logger = require("../logger");
var _FormattedMessage = require("./FormattedMessage");
var _shared = require("./shared");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const OfferHintsModal = /*#__PURE__*/ (0, _react.lazy)(async ()=>Promise.resolve().then(()=>_interopRequireWildcard(require(/* webpackChunkName: "offer-hints-modal" */ './Modal'))));
const OfferHints = (param)=>{
    let { offers, isOfferHintsModalOpen } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { setIsOfferHintsModalOpen } = (0, _contexts.useCheckoutOfferHints)();
    const closeModalHandler = (0, _react.useCallback)(()=>setIsOfferHintsModalOpen(false), [
        setIsOfferHintsModalOpen
    ]);
    const openModalHandler = (0, _react.useCallback)(()=>setIsOfferHintsModalOpen(true), [
        setIsOfferHintsModalOpen
    ]);
    const isAnyOfferPresent = offers.length > 0;
    (0, _logger.logDebug)(">>> rendering ".concat(offers.length, " offer hints"));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            isAnyOfferPresent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_checkoutUi.ActionBanner, {
                "data-analytics": "offer-hints",
                "data-testid": getTestId('offer-hints-main-banner'),
                onClick: openModalHandler,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                                id: "dontMissOut"
                            }),
                            " (",
                            offers.length,
                            ")"
                        ]
                    })
                })
            }) : null,
            isAnyOfferPresent && isOfferHintsModalOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Suspense, {
                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.Loading, {}),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OfferHintsModal, {
                    isOpen: Boolean(isAnyOfferPresent && isOfferHintsModalOpen),
                    offers: offers,
                    onClose: closeModalHandler
                })
            }) : null
        ]
    });
};
exports.OfferHints = OfferHints;
